import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChatBubble7: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chat-bubble-7"><path d="M12 2.5C17.483 2.5 22 6.71457 22 12C22 17.2854 17.483 21.5 12 21.5C10.6896 21.5 9.43585 21.2603 8.28613 20.8232C7.67144 20.5895 7.02385 20.5182 6.4209 20.6426C5.58008 20.816 4.71813 20.9282 3.82422 20.9834C3.56955 20.9991 3.32383 20.8844 3.17285 20.6787C3.02214 20.4731 2.98592 20.2049 3.07715 19.9668C3.27289 19.4563 3.44982 18.9492 3.59863 18.4404C3.76274 17.8793 3.60303 17.2196 3.21191 16.5371C2.43976 15.1898 2 13.6433 2 12C2 6.71457 6.51697 2.5 12 2.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChatBubble7;
